import { Navigate, Outlet } from 'react-router-dom';
import { useAuth, resolveAuthenticatedRedirect } from '@/shared/lib/auth';
import { isMasterEmail } from '@/shared/lib/navigation';
import { FullPageLoader } from '@/shared/components/full-page-loader';

/** Layout/guard das telas do master Fixe (Permissões, Custos de IA). */
export function MasterGuard() {
  const { user, isLoading, authSource, startPath } = useAuth();

  if (isLoading) return <FullPageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isMasterEmail(user.email)) {
    return <Navigate to={resolveAuthenticatedRedirect(user, authSource, startPath)} replace />;
  }

  return <Outlet />;
}
